
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../../core/services/auth.service';
import { FileElement } from './fileElement.model';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { DocumentService } from '../../home/services/document.service';

@Injectable()
export class InstructionDocsService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private docService: DocumentService
  ) {}

  getAll(): Promise<FileElement[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .get<FileElement[]>(`${environment.instructionDocsUrl}`, {
        headers: headers
      })
      .toPromise();
  }

  createDirectory(directoryName: string): Promise<string> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .post<string>(
        `${environment.instructionDocsUrl}/createDirectory/${directoryName}`,
        {
          headers: headers
        }
      )
      .toPromise();
  }
 
  renameDirectory(
    oldDirectoryName: string,
    newDirectoryName: string
  ): Promise<string> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .put<string>(
        `${environment.instructionDocsUrl}/renameDirectory/${oldDirectoryName}/${newDirectoryName}`,
        {
          headers: headers
        }
      )
      .toPromise();
  }

  deleteDirectory(
    directoryName: string,
    forceDelete: boolean = false
  ): Promise<boolean> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .delete<boolean>(
        `${environment.instructionDocsUrl}/directory/${directoryName}/${forceDelete}`,
        {
          headers: headers
        }
      )
      .toPromise();
  }

  upload(document: FileElement, file: File): Promise<boolean> {
    const headers = this.authService.getBearerRequestHeaders();

    const data = new FormData();
    data.set('document.name', document.name.toString());
    data.set('document.parent', document.parent.toString());
    data.set('document.isFolder', document.isFolder.toString());
    data.set('file', file);

    return this.httpClient
      .put<boolean>(`${environment.instructionDocsUrl}/upload`, data, {
        headers
      })
      .toPromise();
  }

  view(document: FileElement): void {
    const fileExtension = document.name.substr(
      document.name.lastIndexOf('.') + 1
    );
    this.getFileBy(document, fileExtension).subscribe(response => {
      this.docService.download(response, document.name);
    });
  }

  cleanDirectoryName(name: string) : string {
    // remove all reserved characters from folder name
    name = name.replace(/[<>:"\\\/\|\?\*0]/g, "");
    var last = name[name.length - 1];
    // last character cannot be space or period
    if (last === ' ' || last === '.') {
      name = name.substring(0, name.length - 1);
    }
    return name;
  }

  private getFileBy(
    document: FileElement,
    extension: string
  ): Observable<Blob> {
    const headers = this.authService.getBearerRequestHeaders();
    const docType = this.docService.getDocumentTypeBy(extension);

    return this.httpClient
      .get<Blob>(
        `${environment.instructionDocsUrl}/file/${document.parent}/${document.name}`,
        {
          headers: headers,
          responseType: 'blob' as 'json'
        }
      ).pipe(
      map(res => {
        return new Blob([res], { type: docType });
      }));
  }

  deleteFile(directoryName: string, fileName: string): Promise<boolean> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .delete<boolean>(
        `${environment.instructionDocsUrl}/file/${directoryName}/${fileName}`,
        {
          headers: headers
        }
      )
      .toPromise();
  }

  renameFile(
    directoryName: string,
    fileName: string,
    newFileName: string
  ): Promise<boolean> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient
      .put<boolean>(
        `${environment.instructionDocsUrl}/renameFile/${directoryName}/${fileName}/${newFileName}`,
        {
          headers: headers
        }
      )
      .toPromise();
  }
}
